<template>
  <v-navigation-drawer
    v-model="drawer"
    :clipped="$vuetify.breakpoint.lgAndUp"
    class="navigation-drawer"
    width="280"
    app
    touchless
  >
    <nested-menu
      :menu-items="menu"
    />
  </v-navigation-drawer>
</template>

<script>
import NestedMenu from './MenuItem.vue'
import { createNamespacedHelpers } from 'vuex'

const { mapGetters, mapActions } = createNamespacedHelpers('base/config')
export default {
  name: 'TheNavigationDrawer',

  components: {
    NestedMenu
  },

  data () {
    return {
      drawer: null,
      pollInterval: null
    }
  },

  computed: {
    ...mapGetters({
      menu: 'menu',
      user: 'user',
      hasGeneratedReportsAccess: 'hasGeneratedReportsAccess'
    })
  },

  mounted () {
    if (this.hasGeneratedReportsAccess) {
      this.pollInterval = setInterval(() => {
        this.fetchUnviewedReportsCount()
      }, 60000)
    }
  },

  beforeDestroy () {
    clearInterval(this.pollInterval)
  },

  methods: {
    ...mapActions({
      fetchUnviewedReportsCount: 'fetchUnviewedReportsCount'
    }),

    toggle () {
      this.drawer = !this.drawer
    }
  }
}
</script>

<style scoped>
.navigation-drawer {
  background-color: #1F2937 !important;
}

@media (max-width: 960px) {
  .navigation-drawer {
    z-index: 1200 !important;
  }
}
</style>
